<template>
  <div :class="$vssWidth > 1400 ? 'content' : 'content2'">
    <div class="cadastro">
      <p class="titulo">DADOS PESSOAIS</p>
      <form @submit.prevent="atualizarCadastro">
      <div class="cadastro-form">
        <div class="form-left">
          <p class="label">Nome: *</p>
          <input v-model="formCadastro.nomeCompleto" type="text" name="nome" required placeholder="digite seu nome">
        </div>
        <div class="form-right">
          <p class="label">Celular: *</p>
          <input v-model="formCadastro.telefone" v-mask="'(##) #####-####'" type="text" name="celular" required placeholder="(00) 00000-0000">
        </div>
      </div>
      <p class="titulo margin-top">ENDEREÇO / LOCALIZAÇÃO</p>
      <div class="cadastro-form">
        <div class="form-left">
          <p class="label">Cep: *</p>
          <input v-model="formCadastro.enderecoCep" v-mask="'#####-###'" required type="text" name="cep" placeholder="00000-000" class="cep">
        </div>
        <div class="form-right">
        </div>
        <div class="form-spam">
          <p class="label">Rua / Avenida / Logradouro: *</p>
          <input v-model="formCadastro.enderecoRua" type="rua" name="rua" required placeholder="digite o nome da rua, avenida ou logradouro">
        </div>
        <div class="form-left">
          <p class="label">Número: *</p>
          <input v-model="formCadastro.enderecoNumero" type="text" name="senha" placeholder="digite o número da residência">
        </div>
        <div class="form-right">
         <p class="label">Complemento: *</p>
          <input v-model="formCadastro.enderecoComplemento" type="text" name="complemento" placeholder="complemento do endereço">
        </div>
        <div class="form-left">
         <p class="label">Bairro: *</p>
          <input v-model="formCadastro.enderecoBairro" type="text" name="bairro" placeholder="digite o bairro">
        </div>
        <div class="form-right">
          <p class="label">Cidade: *</p>
          <input v-model="formCadastro.enderecoCidade" type="text" name="cidade" placeholder="digite a cidade">
        </div>
        <div class="form-left">
          <p class="label">UF: *</p>
          <select required v-model="formCadastro.enderecoUF" class="uf">
            <option v-for="estado in estados" :key="estado" :value="estado">{{estado}}</option>
          </select>
        </div>
        </div>
      <button class="bt-cadastro">Confirmar cadastro</button>
      </form>
    </div>
  </div>
</template>

<script>
import { dbCadastro } from '@/firebase_cadastro.js'
import VueScreenSize from 'vue-screen-size'

export default {
  name: 'Cadastrar',
  mixins: [VueScreenSize.VueScreenSizeMixin],
  data: function () {
    return {
      usuario: {},
      estados: [
        'AC',
        'AL',
        'AP',
        'AM',
        'BA',
        'CE',
        'DF',
        'ES',
        'GO',
        'MA',
        'MT',
        'MS',
        'MG',
        'PA',
        'PB',
        'PR',
        'PE',
        'PI',
        'RJ',
        'RN',
        'RS',
        'RO',
        'RR',
        'SC',
        'SP',
        'SE',
        'TO'
      ],
      formCadastro: {
        telefone: this.$store.state.usuario.usuario.Telefone,
        nomeCompleto: this.$store.state.usuario.usuario.NomeCompleto,
        enderecoCep: null,
        enderecoRua: null,
        enderecoNumero: null,
        enderecoBairro: null,
        enderecoComplemento: null,
        enderecoCidade: null,
        enderecoUF: null
      }
    }
  },
  created () {
    this.getCliente()
    document.title = 'Atualizar Cadastro - Ilha do Caranguejo'
  },
  methods: {
    async getCliente () {
      var docRef = dbCadastro.collection('Clientes').doc(this.$store.state.usuario.usuario.Email)
      docRef
        .get()
        .then(doc => {
          if (doc.exists) {
            this.documentoProps = doc.data()
            this.formCadastro.enderecoCep = doc.data().EnderecoCep
            this.formCadastro.enderecoRua = doc.data().EnderecoRua
            this.formCadastro.enderecoNumero = doc.data().EnderecoNumero
            this.formCadastro.enderecoBairro = doc.data().EnderecoBairro
            this.formCadastro.enderecoComplemento = doc.data().EnderecoComplemento
            this.formCadastro.enderecoCidade = doc.data().EnderecoCidade
            this.formCadastro.enderecoUF = doc.data().EnderecoUF
          } else {
            console.log('Erro ao adquirir documento')
          }
        })
        .catch(erro => {
          console.log('Erro ao adquirir documento:', erro)
        })
    },
    atualizarCadastro () {
      let loader = this.$loading.show({
        container: null,
        fullPage: true,
        color: '#F85E28',
        loader: 'spinner',
        width: 100,
        height: 100,
        backgroundColor: '#ffffff',
        opacity: 0.5,
        zIndex: 999
      })
      this.usuario = {
        NomeCompleto: this.formCadastro.nomeCompleto,
        PrimeiroNome: this.formCadastro.nomeCompleto.split(' ')[0],
        UltimoNome: this.formCadastro.nomeCompleto.split(' ')[1],
        Telefone: this.formCadastro.telefone,
        EnderecoCep: this.formCadastro.enderecoCep,
        EnderecoRua: this.formCadastro.enderecoRua,
        EnderecoNumero: this.formCadastro.enderecoNumero,
        EnderecoBairro: this.formCadastro.enderecoBairro,
        EnderecoComplemento: this.formCadastro.enderecoComplemento,
        EnderecoCidade: this.formCadastro.enderecoCidade,
        EnderecoUF: this.formCadastro.enderecoUF
      }
      dbCadastro.collection('Clientes').doc(this.$store.state.usuario.usuario.Email).set(this.usuario)
      loader.hide()
      this.$fire({
        text: 'Dados atualizados com sucesso!'
      }).then(r => {
        this.$router.push({name: 'Minha Conta'})
      })
    }
  }
}
</script>

<style scoped>
.content, .content2 {
  max-width: 1174px;
  margin: 0 auto;
  padding: 20px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  grid-template-areas:
    "etapas"
    "etapas-titulo"
    "cadastro"
    "endereco"
}

.content2 {
  max-width: 1000px;
  padding: 0 200px 0 0;
}

@media (max-width: 960px) {
  .content, .content2 {
    margin: 0;
    padding: 20px;
    grid-template-columns: 1fr;
    grid-template-columns: 100%;
    grid-template-areas:
      "etapas"
      "etapas-titulo"
      "cadastro"
      "endereco"
  }
}

.bt-facebook {
 background: #4266AE;
 margin: 10px 0px;
 width: 60%;
}

.bt-login:hover {
  background: #186B65;
  transform: scale(1.1);
}

.bt-google {
  background: #4286F5;
  margin: 10px 0px;
  width: 60%;
}

.bt-google:hover {
  background: #4286F5;
}

.titulo {
  font-size: 1.2rem;
  color: #2E9189;
  font-weight: 600;
  border-bottom: 1px solid #2E9189;
  padding: 5px 0;
  margin: 0 0 15px 0;
}

.form {
  margin: 0 auto;
  padding: 0 20px;
}

.form p {
  padding: 0 5%;
  color: #333;
}

.label {
  text-align: left;
}

.form button {
  margin: 10px auto;
}

button {
  color: #fff;
  padding: 10px 20px;
  border-radius: 4px;
  border: 0;
  font-size: 1.05em;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(30, 60, 90, 0.2);
  transition: all 0.3s;
}

button:hover {
  transform: scale(1.1);
}

.bt-login {
  background: #2E9189;
}

.bt-login:hover {
  background: #186B65;
}

/* CADASTRO */
.cadastro {
  grid-area: cadastro;
}

.endereco {
  grid-area: endereco;
}

.cadastro, .endereco {
  width: 60%;
  justify-self: center;
  background: #fff;
  box-shadow: 5px 5px 15px 0px rgba(44, 44, 44, 0.15);
  padding: 10px;
}

.cadastro, .endereco {
  width: 60%;
  padding: 10px;
}

.cadastro2 {
  width: 70%;
  padding: 0 25% 0 0;
}

.cadastro-form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 0 0 0 10px;
}

.form-left, .form-right, .form-spam {
  display: grid;
  justify-items: start;
  text-align: left;
  padding: 12px 0 0 0;
}

.form-spam {
  grid-column: span 2;
  margin: 0 0 0 0;
}

.cep {
  width: 130px !important;
}

.uf {
  width: 100px !important;
}

.bt-cadastro {
  background: #2E9189;
  margin: 20px 0;
}

.bt-cadastro:hover {
  background: #186B65;
}

.margin-top {
  margin: 25px 0 0 0;
}

.descricao {
  color: #2E9189;
  font-weight: 500;
  padding: 10px 0;
}

@media (max-width: 1000px) {
  .etapas {
    margin-top: 10px;
  }
  .etapas input {
    width: 30px;
    height: 30px;
    padding-top: 5px;
  }
  .cadastro {
    width: 98%;
    padding: 10px 2px 25px 2px;
  }
  .cadastro-form {
    grid-template-columns: 1fr;
    gap: 0;
  }
  .form-spam {
    grid-column: 1;
  }
  .login {
    width: 98%;
    justify-self: center;
    padding: 10px 0;
  }
  .bt-google, .bt-facebook {
    width: 100%;
  }
  .primeiro {
    text-align: left;
    margin: 0 0 0 5px;
  }
  .ultimo {
    text-align: right;
    margin: 0 5px 0 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/AtualizarCadastro.vue